import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
import WarningIcon from '@material-ui/icons/Warning';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Link } from "react-router-dom";
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { LuxFwComboBox } from 'luxFw/palettes/Standart';

import {
  cantinaPorTurma,
  cantinaPorIdade,
  listaEscolas,
  hideMessage,
  showAuthLoader,
  setCombo
} from 'actions/Cantina';

import { selecionaModulos } from 'actions/Auth';
import { onChangeCombo } from 'actions/Global';

import TurmaCard from "./partials/_cardturma";
import IdadeCard from "./partials/_cardIdade";

const styles = theme => ({

  headerTopRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    flexWrap: "wrap",
  },

  chipPresente: {
    backgroundColor: "#0F6B5B",
    color: "#FFFFFF",
    fontWeight: 700,
    border: "2px solid #0F6B5B",
    fontSize: 16,
    padding: "4px 12px",
  },

  chipAusente: {
    border: "1px solid #C70707",
    color: "#C70707",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },

  chipRestricao: {
    border: "1px solid #B78809",
    color: "#B78809",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },

  chips: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
  },

  chipsTopRow: {
    display: 'flex',
    gap: 8,
    justifyContent: 'center',
  },

  chipBottomRow: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 4,
  },

  cardWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  contentContainer: {
    width: "100%",
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(2),
    [theme.breakpoints.up("lg")]: {
      maxWidth: 1400,
    }
  },

  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    border: "1px solid #F4F4F7",
    borderRadius: 15,
    width: "100%",
  },

  cardHeader: {
    backgroundColor: "#FFFFFF",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
  },

  cardBody: {
    flex: 1,
    overflowY: "auto",
    padding: 16,
  },

  turmasGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },

  tabLabel: {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 600,
    fontSize: 16,
    [theme.breakpoints.up("lg")]: {
      fontSize: 22,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    }
  }

});

class Cantina extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      indexTab: 0
    };
  }

  componentDidMount() {
    this.props.listaEscolas();
  }

  handleChangeTab = (event, indexTab) => {
    this.setState({ indexTab });
  };

  handleAcessarRestricaoTurma = (restricoes, idTurma) => {
    if (restricoes > 0) {
      this.parar();
      this.props.history.push(`/restricao-alimentar?idTurma=${idTurma}`);
    }
  };

  handleAcessarRestricaoIdade = (restricoes, idade) => {
    if (restricoes > 0) {
      this.parar();
      this.props.history.push(`/restricao-alimentar?idade=${idade}`);
    }
  };

  handleLuxFwComboBox = (name, object, value) => {
    this.props.setCombo(value.id);
    this.props.cantinaPorTurma({ idEscola: value.id });
    this.props.cantinaPorIdade({ idEscola: value.id });
    this.executar();
  };

  executar = () => {
    if (this.props.idEscola !== 0) {
      this.props.cantinaPorTurma({ idEscola: this.props.idEscola });
      this.props.cantinaPorIdade({ idEscola: this.props.idEscola });
    }

    this.timeout = setTimeout(() => {
      this.executar();
    }, 120000);
  };

  parar = () => {
    clearTimeout(this.timeout);
  };

  render() {

    const { classes } = this.props;
    const { indexTab } = this.state;

    return (
      <div className={classes.cardWrapper}>
        <div className={classes.contentContainer}>

          <Card className={`shadow border-0 ${classes.card}`}>

            <CardHeader className={classes.cardHeader}>

              <div className={classes.headerTopRow}>

                <Link
                  to="/app/inicio"
                  onClick={() => this.props.selecionaModulos()}
                  style={{ textDecoration: "none" }}
                >
                  <AiFillHome size={20} style={{ color: 'silver' }} />
                </Link>

                <LuxFwComboBox
                  name="idEscola"
                  label="Escolas"
                  tamanho="3"
                  lista={this.props?.listaDeEscolas || []}
                  valor={this.props.idEscola}
                  onChange={this.handleLuxFwComboBox}
                />

                <div className={classes.chips}>

                  {indexTab === 0 && (
                    <>
                      <div className={classes.chipsTopRow}>
                        <Chip
                          className={classes.chipAusente}
                          label={`Total: ${this.props.registrosCantinaTurma.totalAusente} Alunos ausentes`}
                          variant="outlined"
                        />

                        <Chip
                          label={`Total: ${this.props.registrosCantinaTurma.totalRestricoes} restrições`}
                          variant="outlined"
                          className={classes.chipRestricao}
                          icon={<WarningIcon />}
                        />
                      </div>

                      <div className={classes.chipBottomRow}>
                        <Chip
                          label={`Total: ${this.props.registrosCantinaTurma.totalPresente} Alunos presentes`}
                          className={classes.chipPresente}
                        />
                      </div>
                    </>
                  )}

                  {indexTab === 1 && (
                    <>
                      <div className={classes.chipsTopRow}>
                        <Chip
                          className={classes.chipAusente}
                          label={`Total: ${this.props.registrosCantinaIdade.totalAusente} Alunos ausentes`}
                          variant="outlined"
                        />

                        <Chip
                          label={`Total: ${this.props.registrosCantinaIdade.totalRestricoes} restrições`}
                          variant="outlined"
                          className={classes.chipRestricao}
                          icon={<WarningIcon />}
                        />
                      </div>

                      <div className={classes.chipBottomRow}>
                        <Chip
                          label={`Total: ${this.props.registrosCantinaIdade.totalPresente} Alunos presentes`}
                          className={classes.chipPresente}
                        />
                      </div>
                    </>
                  )}

                </div>

                <Tabs
                  value={indexTab}
                  onChange={this.handleChangeTab}
                  indicatorColor="primary"
                  textColor="primary"
                  TabIndicatorProps={{ style: { height: 2 } }}
                >
                  <Tab label="Turma" className={classes.tabLabel} />
                  <Tab label="Idade" className={classes.tabLabel} />
                </Tabs>

              </div>

            </CardHeader>

            <CardBody className={classes.cardBody}>
              <div className={classes.turmasGrid}>

                {indexTab === 0 &&
                  this.props.registrosCantinaTurma.cantinaPorTurma.map((item) => (
                    <TurmaCard
                      key={item.idTurma}
                      turma={item.sigla}
                      presentes={item.presente}
                      ausentes={item.ausente}
                      restricoes={item.restricoes}
                      onClick={() =>
                        this.handleAcessarRestricaoTurma(item.restricoes, item.idTurma)
                      }
                    />
                  ))}

                {indexTab === 1 &&
                  this.props.registrosCantinaIdade.cantinaPorIdade.map((item) => (
                    <IdadeCard
                      key={item.idade}
                      idade={item.idade}
                      presentes={item.presente}
                      ausentes={item.ausente}
                      restricoes={item.restricoes}
                      onClick={() =>
                        this.handleAcessarRestricaoIdade(item.restricoes, item.idade)
                      }
                    />
                  ))}

              </div>
            </CardBody>

          </Card>

        </div>
      </div>
    );
  }
}

Cantina.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (props) => {
  const {
    loader,
    alertMessage,
    showMessage,
    registrosCantinaTurma,
    registrosCantinaIdade,
    listaDeEscolas,
    combo,
    idEscola
  } = props.cantina;

  const { selecionarModulo } = props.auth;

  return {
    loader,
    alertMessage,
    showMessage,
    listaDeEscolas,
    registrosCantinaTurma,
    selecionarModulo,
    registrosCantinaIdade,
    combo,
    idEscola
  };
};

export default connect(
  mapStateToProps,
  {
    hideMessage,
    cantinaPorTurma,
    listaEscolas,
    cantinaPorIdade,
    showAuthLoader,
    onChangeCombo,
    setCombo,
    selecionaModulos
  }
)(withStyles(styles)(Cantina));